import React, { useEffect, useState } from 'react';
import { Hidden } from '@material-ui/core';
import { Form, Formik, FormikProps } from 'formik';
import { useHistory, useLocation } from 'react-router';
import LoadingCircle from '@cpg-its/ads.common.loading-circle';
import { useDispatch, useSelector } from 'react-redux';
import { PageContainer } from '../../../../global/components/layout/page-container';
import { PortalLandingBanner } from '../map-landing/components/portal-landing-banner';
import { MainContent } from '../../../../global/components/layout/main-content-container';
import { MapPortalProps } from '../../models/arc-epi-props';
import { TcsmStates } from '../../../../root/tcsm-model';
import { TcsmSiteSettingsProps } from '../../../../global/models/epi-model';
import { setUserContext } from '../../../../global/ducks/app-context';
import { UserContext } from '../../../../global/models/app-context-model';
import { useDeserializedToken } from '../../components/use-deserialized-token';
import { CicSettings } from './model';
import { PageHeader } from '../../../../global/components/layout/page-header';
import { SideBarContent } from '../../../../global/components/layout/sidebar-content';
import { WysiwygWithReactLink } from '../../../../global/components/wysiwyg-with-react-link';
import { ButtonWrapper } from '../../../../global/components/layout/button-wrapper';
import { buttonStyles } from '../../../../global/constants/theme/styles/components/buttonstyles';
import { TcsmModal } from '../../../../global/components/tcsm-modal';
import { postOptIn } from '../../../../global/ducks/person-prc-api';
import { FormTypes } from '../../../account-info/models/form-models';
import { FormWrapper } from '../../../../global/components/form-wrapper';
import { FormField } from '../../../../global/components/form-element/form-field';
import { useGpsType } from '../../../../global/hooks/useGpsType';
import { GpsType } from '../../../../global/components/layout/layout-models';
import { GuidedProcessSupportBlock } from '../../../../global/components/guided-process-support-block';
import { getRoles } from '../../../../global/ducks/wam-api';
import { setRoleObject } from '../../../../global/ducks/authenticated-slice';
import { ContentSpacer } from '../../../../global/components/layout/generic-content-spacer';



export function CicOptInForm() {

	const portalProps = useSelector<TcsmStates, MapPortalProps>(state => state.epiProps?.mapPortalSettingsState?.epiContent);
	const roles = useSelector<TcsmStates, string[]>(state => state?.authenticatedState?.roles);
	const siteSettings = useSelector<TcsmStates, TcsmSiteSettingsProps>(state => state.epiProps?.siteSettingsState?.siteSettings);
	const cicSettings = useSelector<TcsmStates, CicSettings>(state => state.epiProps?.cicSettingsState?.epiContent);
	const guid = useSelector<TcsmStates, string>(state => state.authenticatedState.clientGuid);
	const dispatch = useDispatch();
	const buttonClass = buttonStyles();
	const [open, setOpen] = useState(false);
	const [openElectronicAgreement, setopenElectronicAgreement] = useState(false);
	const gpsItem = useGpsType(GpsType.CIC_OPT_IN_FORM);
	const history = useHistory();
	const { state } = useLocation<any>();
	useEffect(() => {

		dispatch(setUserContext(UserContext.MINIMAP));
	}, []);


	const token = useDeserializedToken();
	const name = `${token?.person?.fn} ${token?.person?.ln}`;
	let matchedRoles = portalProps?.roleNameMapping?.filter(a => roles?.includes(a.key))?.map(a => a?.value);

	if (!matchedRoles) {
		matchedRoles = [];
	}
	let roleMessage = matchedRoles?.length > 1 ?
		portalProps?.multipleAdminRoleText?.replace('{role}', matchedRoles?.join(', ')) :
		portalProps?.adminRoleText?.replace('{role}', matchedRoles[0]);


	if (matchedRoles?.length === 0) {
		roleMessage = '';
	}

	const onSubmit = () => {
		dispatch(postOptIn(
			{
				client_number: state?.clientId,
			},
			() => {
				dispatch(getRoles(
					guid,
					(res) => {
						dispatch(setRoleObject(res?.data?.role_assignments || {}));
					},
				));
				history.push(`${state?.returnUrl}?success=${FormTypes.CIC_OPT_IN_SUCCESS}`);
			},
		));
	};


	if (!portalProps || !cicSettings) {
		return <LoadingCircle />;
	}

	return (

		<PageContainer>
			<PortalLandingBanner
				userFullName={name}
				userRole={roleMessage}
				userGreeting={siteSettings?.greetingText}
				brandImage={portalProps?.brandImage}
				brandImageAltText={portalProps?.brandImageAltText}
				bannerImageUrl={portalProps?.bannerImageLink}
				bannerImageAltText={portalProps?.bannerImageAltText}
				bannerImage={portalProps?.bannerImage} />

			<MainContent>
				<PageHeader
					headerText={cicSettings?.optInFormTitle}
				/>
				<Hidden mdUp>
					<SideBarContent>
						<GuidedProcessSupportBlock title={gpsItem?.title} contents={gpsItem?.contents} />
					</SideBarContent>
				</Hidden>
				<Formik
					initialValues={{ optin: false }}
					onSubmit={onSubmit}
					enableReinitialize
				>
					{(formProps: FormikProps<any>) =>
						<Form >
							<FormWrapper
								formikProps={formProps}
								submitText={cicSettings?.optInSubmitButtonText}
								cancelText={cicSettings?.optInMoreInfoButtonText}
								onCancel={() => setOpen(true)}
								submitDisabled={!formProps?.values?.optin}>
								<ContentSpacer>
									<WysiwygWithReactLink
										content={cicSettings?.optInFormDescription}
										externalHanlder={() => setopenElectronicAgreement(true)}
									/>
								</ContentSpacer>
								<FormField
									name='optin'
									label={cicSettings?.optInFormCheckBoxContent}
									component='checkBox'
									touched={formProps.touched}
									errors={formProps.errors}
									value={formProps?.values?.optin ?? false}
									checked={formProps?.values?.optin ?? false}
								/>
							</FormWrapper>

						</Form>}
				</Formik>
			</MainContent>
			<Hidden smDown>
				<SideBarContent>
					<GuidedProcessSupportBlock title={gpsItem?.title} contents={gpsItem?.contents} />
				</SideBarContent>
			</Hidden>
			<TcsmModal
				open={open}
				handleClose={() => setOpen(false)}
			>
				<h2 className='modal-content-title'>{cicSettings?.optInMoreInfoModalTitle}</h2>
				<WysiwygWithReactLink content={cicSettings?.optInMoreInfoModalContent} />
				<ButtonWrapper flexEnd>
					<button type='button' className={buttonClass.tertiaryButton} onClick={() => history.goBack()} >{cicSettings?.optInFormReturnToHomeText}</button>
					<button type='button' className={buttonClass.primaryButton} onClick={() => setOpen(false)} >{cicSettings?.optInFormMoreInfoConfirmText}</button>
				</ButtonWrapper>
			</TcsmModal>
			<TcsmModal
				open={openElectronicAgreement}
				handleClose={() => setopenElectronicAgreement(false)}
			>
				<ContentSpacer>
					<img src={cicSettings?.electronicDisclosureModalIcon} className='modal-header-logo' alt='electronic-agreement' />
				</ContentSpacer>
				<WysiwygWithReactLink content={cicSettings?.electronicDisclosureContent} />

			</TcsmModal>
		</PageContainer>
	);

}


